module.exports = __webpack_public_path__ + "static/img/demo_cate.8bdc1d4b.jpg";